<template>
  <div>
    <div v-if="loading">
      <b-spinner
                 variant="primary"
                 style="width: 3rem; height: 3rem"
                 label="Large Spinner"></b-spinner>
    </div>

    <div v-if="!loading && reps.length > 0">


      <!-- Customers -->
      <div
           class="row">
        <div class="col-12">
          <input
                 ref="customerordersearch"
                 type="text"
                 class="form-control"
                 style="max-width: 200px"
                 placeholder="search customers"
                 @keyup="filterCustomers($event)" />
          <br>

          <span class="font-size-11 text-primary ">Click the customer for detailed balances and click the addresses to
            open up in maps, or the tel to call.</span>

        </div>

        <div
             class="col text-muted my-3"
             v-if="customers.filter((x) => !x.hidden).length == 0">
          No Customers allocated
        </div>

        <div
             class="col-6 col-md-4 col-lg-3 mt-3"

             v-for="customer in customers.filter((x) => !x.hidden)"
             :key="customer.id">
          <div class="card is-link-card p-2 text-center h-100" @click="viewCustomer(customer.id)">
            <div>
              <strong>{{ customer.name }}</strong><br />
              <small class="text-black-50">{{ customer.trading_as }}</small>
              <p>{{ customer.area }}</p>
            </div>
            <div class="pointer text-primary">
              BAL {{ customer.current_balance | currency }}

            </div>

            <div class="my-2 font-weight-bold">
              {{ customer.branch.code }}
            </div>
          </div>
        </div>
      </div>



      <!-- AGging Balances -->
      <b-modal
               title="Customer Balance"
               :hide-footer="true"
               v-model="customerBalanceModal">
        <div class="row" v-if="selectedCustomer != null">
          <div class="col">
            <table class="table table-sm mt-2">

              <table-row class="text-success" :no-border='true' label="Check In" v-if="checkedIn">
                Checked In
              </table-row>


              <table-row :no-border='true' label="Check In" v-if="!checkedIn">
                <button class="btn btn-primary btn-sm btn-block mt-2" @click="logVisit('In')">Check In Now</button>
              </table-row>

              <table-row :no-border='true' label="Check Out" v-if="checkedIn">


                <select
                        class="form-control"
                        v-model="orderStatus">
                  <option value="Ordered">Ordered</option>
                  <option value="No Order">No Order</option>
                </select>

                <select
                        class="form-control mt-2"
                        v-model="orderReason">
                  <option value="General Order">General Order</option>
                  <option value="Customer Has Enough Stock">Customer Has Enough Stock</option>
                  <option value="Out Of Stock">Out Of Stock</option>
                  <option value="Out Priced">Out Priced</option>
                  <option value="Pending">Pending</option>
                  <option value="Outstanding Payments">Outstanding Payments</option>
                </select>

              
                  <input
                  maxlength="100"
                  placeholder="remarks"
                         class="form-control mt-2"
                         v-model="orderRemarks" />
              
               

                <button class="btn btn-primary btn-sm btn-block mt-2" @click="logVisit('Out')">Check Out</button>
              </table-row>


              <table-row label="">
                &nbsp;<br>
              </table-row>


              <table-row label="Status">{{ selectedCustomer.status }}</table-row>


              <table-row label="Name">{{
                selectedCustomer.name
              }}</table-row>


              <table-row label="Rapid Code">{{
                selectedCustomer.rapid_code
              }}</table-row>


              <table-row label="Branch">{{
                selectedCustomer.branch.name
              }}</table-row>

              <table-row label="Account Type">{{
                selectedCustomer.account_type
              }}</table-row>

              <table-row label="Balance" class="font-weight-bold">{{
                selectedCustomer.current_balance | currency
              }}</table-row>

              <table-row label="Credit Limit">{{
                selectedCustomer.credit_limit | currency
              }}</table-row>

              <table-row label="Max Credit">{{
                selectedCustomer.max_credit_limit | currency
              }}</table-row>

              <table-row label="">
                &nbsp;<br>
              </table-row>

              <table-row label="Aging Current">{{
                selectedCustomer.aging_current | currency
              }}</table-row>

              <table-row label="Aging 30">{{
                selectedCustomer.aging_30 | currency
              }}</table-row>

              <table-row label="Aging 60" class="text-info">{{
                selectedCustomer.aging_60 | currency
              }}</table-row>

              <table-row label="Aging 90" class="text-warning">{{
                selectedCustomer.aging_90 | currency
              }}</table-row>

              <table-row label="Aging 90+" class="text-danger">{{
                selectedCustomer.aging_90_plus | currency
              }}</table-row>

              <table-row label="">
                &nbsp;<br>
              </table-row>



              <table-row label="Physical">


                <a
                   :href="'https://www.google.com/maps/search/?api=1&query=' +
                    selectedCustomer.physical_address
                    "
                   target="new">{{ selectedCustomer.physical_address }}
                </a>
              </table-row>

              <table-row label="Area">{{ selectedCustomer.area }}</table-row>

              <table-row label="Phone"><a :href="'tel:' + selectedCustomer.phone_1">{{
                selectedCustomer.phone_1
                  }}</a></table-row>

              <table-row label="Phone"><a :href="'tel:' + selectedCustomer.phone_2">{{
                selectedCustomer.phone_2
                  }}</a></table-row>

              <table-row label="Phone"><a :href="'tel:' + selectedCustomer.phone_3">{{
                selectedCustomer.phone_3
                  }}</a></table-row>

              <table-row label="Email"><a :href="'mailto:' + selectedCustomer.email_address">{{
                selectedCustomer.email_address
                  }}</a></table-row>

              <table-row label="Notes">{{ selectedCustomer.notes }}</table-row>

              <table-row icon="lni-database" :noBorder="true" />

              <table-row label="Id">{{ selectedCustomer.id }} </table-row>

              <table-row label="Created">{{
                moment(new Date(selectedCustomer.created_at)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}
              </table-row>
              <table-row label="Updated">{{
                moment(new Date(selectedCustomer.updated_at)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}
              </table-row>
            </table>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import customerRepo from "@/api/repos/customerRepo";
import tableRow from "@/components/common/TableRow";
import visitRepo from "@/api/repos/visitRepo";

export default {
  components: {
    tableRow,
  },

  mounted() {
    this.getData();
  },

  data() {
    return {

      reps: [],

      loading: false,
      checkedIn: false,
      orderStatus: "Ordered",
      orderReason: "General Order",
      orderRemarks: null,
      errors: null,
      submitStatus: null,
      selectedBranch: null,
      selectedCustomer: null,
      customers: [],

      groupSearchText: null,
      customerBalanceModal: false,
      agingCurrent: 0,
      aging30: 0,
      aging60: 0,
      aging90: 0,
      aging90Plus: 0,
      currentBalance: "-",
      creditLimit: "-",
      maxCreditLimit: "-",
      balanceUpdatedOn: "-",
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await customerRepo.balances();
        this.reps = data.reps;
        this.customers = data.customers;
      } catch (error) {
        console.log(error);
      }
    },

    async logVisit(direction) {
      if (direction == "In") {
        this.checkedIn = true;
      } else {
        this.checkedIn = false;
      }


      let lat = null;
      let lng = null;
      let err = null;

      try {
        await this.getLocation().then(
          (location) => {
            lat = location.coords.latitude;
            lng = location.coords.longitude;
          },
          (error) => {
            err = "Browser Error: " + error.message;
          }
        );

        await visitRepo.create({
          direction: direction,
          latitude: lat,
          longitude: lng,
          error: err,
          customer_id: this.selectedCustomer.id,
          order_status: this.orderStatus,
          reason: this.orderReason,
          remarks: this.orderRemarks
        });

        this.$root.$bvToast.toast("Checked " + direction, {
          title: "Success",
          autoHideDelay: 1500,
          variant: "success",
        });


      } catch (e) {
        this.checkedIn = false;
        if (e.response && e.response.status == 400) {
          this.$root.$bvToast.toast("Request an admin to setup your profile", {
            title: "Error",
            autoHideDelay: 1500,
            variant: "danger",
          });
        }
      }
    },

    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          this.$router.push({ path: "no-location" });
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve(pos);
          },
          (err) => {
            reject(err);
          },
          {
            timeout: 10 * 1000,
          }
        );
      });
    },


    filterCustomers(e) {
      let q = e.target.value;
      var t = [];

      this.customers.forEach((x) => {
        x.hidden = true; // Start by assuming customer doesn't match

        if (x.name != null && x.name.toLowerCase().includes(q.toLowerCase())) {
          x.hidden = false;
        }

        if (x.rapid_code != null && x.rapid_code.toLowerCase().includes(q.toLowerCase())) {
          x.hidden = false;
        }

        if (x.trading_as != null && x.trading_as.toLowerCase().includes(q.toLowerCase())) {
          x.hidden = false;
        }

        if (x.area != null && x.area.toLowerCase().includes(q.toLowerCase())) {
          x.hidden = false;
        }

        t.push(x);
      });

      this.customers = t;
    },


    viewCustomer(id) {
      this.customerBalanceModal = true;
      this.customers.forEach((c) => {
        if (c.id == id) {
          this.selectedCustomer = c;
          if (this.selectedCustomer.visit != null) {
            this.checkedIn = true
          }
        }
      });
    },


  },



};
</script>
